import { Injectable } from "@angular/core";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { TipoParentescoEnum } from "src/app/core/enums/tipo-parentesco.enum";
import {
  IParentescoConTiposIdentificacion
} from "src/app/core/models/parentesco/parentesco-interface";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { DateTimeService } from "src/app/core/utils/datetime.service";
import { ValidateData } from "src/app/core/utils/validate-data";
import { TipoIdentificacion } from "../model/tipo-identificacion";
import { ListaTipoIdentificacion } from "../model/tipo-identificacion.enum";
import { ParentescoTipoIdentificacion } from "./../../../core/models/parentesco/parentesco";
import { WresponseData } from "./../../../core/models/worker/wresponse-data";

@Injectable({
  providedIn: "root",
})
export class ValidacionesService {
  private minimaFecha: Date;
  private maximaFecha: Date;

  constructor(private localStorageService: LocalStorageService) {}

  obtenerParentescoValidos(
    parentescos: Array<any>,
    trabajador: WresponseData
  ): Array<IParentescoConTiposIdentificacion> {
    let parentescosValidos: IParentescoConTiposIdentificacion[] = [];
    const reglasParentesco =
      ParentescoTipoIdentificacion.obtenerParenteso(trabajador);

    parentescos.forEach((parentesco) => {
      const id = parentesco.id;
      const reglaParentesco = reglasParentesco[id];
      if (
        !ValidateData.emptyObject(reglaParentesco) &&
        reglaParentesco.afiliar
      ) {
        parentescosValidos.push({
          ...parentesco,
          tiposIdentificacion: reglaParentesco.tiposIdentificacion,
        });
      }
    });

    return parentescosValidos;
  }

  obtenerDocumentosValidos_cambioEstadoCivil(afiliado: WresponseData): any {
    const reglasParentescoConyuge =
      ParentescoTipoIdentificacion.obtenerParenteso(afiliado);
    const id = TipoParentescoEnum.CONYUGE;
    const reglaParentesco = reglasParentescoConyuge[id];

    return reglaParentesco;
  }

  //Se valida los rangos de edad
  obtenerValidacionRangoDeEdad(
    tipoIdentificacion: TipoIdentificacion,
    siDiscapacidad: string
  ) {
    let rangoEdadMin =
      siDiscapacidad == "true" ? 100 : tipoIdentificacion.rangoEdadMin;
    if (
      tipoIdentificacion.valor == ListaTipoIdentificacion.RC.codigo ||
      tipoIdentificacion.valor == ListaTipoIdentificacion.TI.codigo
    ) {
      rangoEdadMin = tipoIdentificacion.rangoEdadMin;
    }
    this.minimaFecha = DateTimeService.calcularRangoFecha(new Date(), rangoEdadMin);
    this.maximaFecha = DateTimeService.calcularRangoFecha(
      new Date(),
      tipoIdentificacion.rangoEdadMax
    );
    return { minimaFecha: this.minimaFecha, maximaFecha: this.maximaFecha };
  }

  obtenerCategoriaC(parentescoId: string, fechaNacimiento, esDiscapacidad) {
    const bAge = this.calculateAge(fechaNacimiento);

    let siParentescoPadres =
      parentescoId === TipoParentescoEnum.PADRE ||
      parentescoId === TipoParentescoEnum.MADRE;

    let siDiscapacidad = esDiscapacidad == "true";

    return (siParentescoPadres && bAge < 60 && !siDiscapacidad);
  }

  //Se valida la acreditacion de cuota monetaria
  validarACM(
    afiliadoDataStorage: object,
    beneficiario: any,
    afiliadoData: any,
    trabajador: WresponseData
  ): boolean {
    const reglasParentesco =
      ParentescoTipoIdentificacion.obtenerParenteso(trabajador);
    const estadoCivilAfiliadoValidas =
      reglasParentesco[beneficiario.parentescoPerCarg.id]
        .estadoCivilAfiliadoValidas;
    const categoriasAfiliadoValidas =
      reglasParentesco[beneficiario.parentescoPerCarg.id]
        .categoriasAfiliadoValidas;

    let siDiscapacidad = beneficiario.discapacidad == "true";
    let edad = 18;
    let ACM = false;

    let isCategoria = this.hasCategoryAvalible(
      afiliadoDataStorage["afiliacion"],
      categoriasAfiliadoValidas
    );
    let isEdad = DateTimeService.calcularEdad(beneficiario.fechaNacimiento) < edad;
    let isEstadoCivil =
      afiliadoData["maritalStatus"] == estadoCivilAfiliadoValidas["casado"] ||
      afiliadoData["maritalStatus"] ==
        estadoCivilAfiliadoValidas["unionLiblre"];

    if (beneficiario.parentescoPerCarg.id == TipoParentescoEnum.HIJASTRO) {
      //hijastro
      siDiscapacidad
        ? (ACM = isCategoria && isEstadoCivil)
        : (ACM = isCategoria && isEdad && isEstadoCivil);
    } else {
      //otro
      siDiscapacidad ? (ACM = isCategoria) : (ACM = false);
    }

    return ACM;
  }

  //Se valida la categoria
  hasCategoryAvalible(
    afiliacion: any,
    categoriasAfiliadoValidas: any
  ): boolean {
    const category = afiliacion.categoria;
    return !ValidateData.emptyObject(categoriasAfiliadoValidas[category]);
  }

  //Se obtiene los parentescos validos
  getParentescosPermitidos(
    parentescos: any,
    beneficiarios: FormArray
  ): Array<any> {
    const controls = beneficiarios.controls;
    controls.forEach((beneficiarioControl: FormGroup, index: number) => {
      let beneficiario = beneficiarioControl.get('parentescoPerCarg').value;
      if (
             beneficiario.id === TipoParentescoEnum.PADRE ||
             beneficiario.id === TipoParentescoEnum.MADRE
           )
             parentescos = parentescos.filter(
             (item) => item.id !== beneficiario.id
             );
           if (beneficiario.id === TipoParentescoEnum.HERMANO)
             parentescos = parentescos.filter(
               (item) =>
                 item.id !== TipoParentescoEnum.PADRE &&
                 item.id !== TipoParentescoEnum.MADRE
           );
    });

    return parentescos;
  }

  //Se valida los parentescos existentes
  validarParentescoExistente(index: number, beneficiarios: FormArray) {
    const error: boolean =
      !ValidateData.emptyObject(beneficiarios) &&
      beneficiarios.length > 1 &&
      beneficiarios.value.some(
        (beneficiario, i) =>
          index !== parseInt(i) &&
          beneficiario.parentescoPerCarg.id ==
            beneficiarios.value[index].parentescoPerCarg.id &&
          (beneficiario.parentescoPerCarg.id === TipoParentescoEnum.PADRE ||
            beneficiario.parentescoPerCarg.id === TipoParentescoEnum.MADRE)
      );
    return error;
  }

  /**
   * Funcion para calcular la edad
   * @param dateA Fecha de nacimiento
   */
  calculateAge(dateA: Date) {
    const today: Date = new Date();
    const birthDate: Date = new Date(dateA);
    let age: number = today.getFullYear() - birthDate.getFullYear();
    const month: number = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getParentescosValidos(
    beneficiarioIndex: FormControl,
    beneficiarios: FormArray
  ) {
    beneficiarios.value.forEach((beneficiario) => {
      let countParentesco = 0;
      let idParentesco = beneficiarioIndex.value.parentescoPerCarg.id;
      let countParentescoHermano = this.contarParentesco(
        beneficiarios,
        TipoParentescoEnum.HERMANO
      );
      switch (idParentesco) {
        case TipoParentescoEnum.PADRE:
          countParentesco = this.contarParentesco(
            beneficiarios,
            TipoParentescoEnum.PADRE
          );
          if (countParentesco > 1) {
            beneficiarioIndex
              .get("parentescoPerCarg")
              .setErrors({ messageError: "No puede seleccionar dos padres" });
          } else if (countParentescoHermano >= 1) {
            beneficiarioIndex.get("parentescoPerCarg").setErrors({
              messageError: "No puede seleccionar padre si ya tiene un hermano",
            });
          }
          break;

        case TipoParentescoEnum.MADRE:
          countParentesco = this.contarParentesco(
            beneficiarios,
            TipoParentescoEnum.MADRE
          );
          if (countParentesco > 1) {
            beneficiarioIndex
              .get("parentescoPerCarg")
              .setErrors({ messageError: "No puede seleccionar dos madres" });
          } else if (countParentescoHermano >= 1) {
            beneficiarioIndex.get("parentescoPerCarg").setErrors({
              messageError: "No puede seleccionar madre si ya tiene un hermano",
            });
          }
          break;

        case TipoParentescoEnum.HERMANO:
          let countParentescoMadre = this.contarParentesco(
            beneficiarios,
            TipoParentescoEnum.MADRE
          );
          countParentesco = this.contarParentesco(
            beneficiarios,
            TipoParentescoEnum.PADRE
          );
          if (countParentesco >= 1 || countParentescoMadre >= 1) {
            beneficiarioIndex.get("parentescoPerCarg").setErrors({
              messageError:
                "No puede seleccionar hermano si agrega a padre o madre",
            });
          }
          break;

        default:
          break;
      }
    });
  }

  contarParentesco(beneficiarios, tipoParentesco): number {
    return beneficiarios.controls.reduce((count, control) => {
      const siParentesco =
        control.get("parentescoPerCarg").value.id == tipoParentesco;
      return count + (siParentesco ? 1 : 0);
    }, 0);
  }

  public desabilitarFormulario(pacs: any) {
    let posisionActual = pacs.length - 1;
    pacs.controls[posisionActual]
      .get("primerNombre")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("tipoDocumentoObjeto")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("parentescoPerCarg")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("numeroDocumento")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual].get("genero").disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("segundoNombre")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual].get("apellido").disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("segundoApellido")
      .disable({ emitEvent: false });
    pacs.controls[posisionActual]
      .get("fechaNacimiento")
      .disable({ emitEvent: false });
  }

  public desabilitarFormularioConyuge(form: any) {
    let posisionActual = form.length - 1;
    form.get("TipoIdConyuge").disable({ emitEvent: false });
    form.get("NumIdConyuge").disable({ emitEvent: false });
    form.get("GeneroConyuge").disable({ emitEvent: false });
    form.get("FechaNaciConyuge").disable({ emitEvent: false });
    form.get("Apellido1Conyuge").disable({ emitEvent: false });
    form.get("Apellido2Conyuge").disable({ emitEvent: false });
    form.get("Nombre1Conyuge").disable({ emitEvent: false });
    form.get("Nombre2Conyuge").disable({ emitEvent: false });
    form.get("TipoSalarioConyuge").disable({ emitEvent: false });
    form.get("SalarioConyuge").disable({ emitEvent: false });
    form.get("TipoIdEmpresaConyuge").disable({ emitEvent: false });
    form.get("NumIdEmpresaConyuge").disable({ emitEvent: false });
    form.get("RazonEmpresaConyuge").disable({ emitEvent: false });
    form.get("OcupacionConyuge").disable({ emitEvent: false });
  }

  public habilitarFormulario(pacs): void {
    let posisionActual = pacs.length - 1;
    pacs.controls[posisionActual].get("parentescoPerCarg").enable();
    pacs.controls[posisionActual].get("tipoDocumentoObjeto").enable();
    pacs.controls[posisionActual].get("numeroDocumento").enable();
    pacs.controls[posisionActual].get("primerNombre").enable();
    pacs.controls[posisionActual].get("segundoNombre").enable();
    pacs.controls[posisionActual].get("genero").enable();
    pacs.controls[posisionActual].get("apellido").enable();
    pacs.controls[posisionActual].get("segundoApellido").enable();
    pacs.controls[posisionActual].get("fechaNacimiento").enable();
  }

  public limpiarFormulario(pacs): void {
    let posisionActual = pacs.length - 1;
    pacs.controls[posisionActual].get("parentescoPerCarg").setValue(null);
    pacs.controls[posisionActual].get("tipoDocumentoObjeto").setValue(null);
    pacs.controls[posisionActual].get("numeroDocumento").setValue(null);
    pacs.controls[posisionActual].get("primerNombre").setValue(null);
    pacs.controls[posisionActual].get("segundoNombre").setValue(null);
    pacs.controls[posisionActual].get("apellido").setValue(null);
    pacs.controls[posisionActual].get("genero").setValue(null);
    pacs.controls[posisionActual].get("segundoApellido").setValue(null);
    pacs.controls[posisionActual].get("fechaNacimiento").setValue(null);
  }
}
